import ReactGA from "react-ga4";

const trackingId = "G-XKPRGZCZYH";
ReactGA.initialize(trackingId);

export default ReactGA;
